import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchJournalEntries } from '@/renderer/services/journalService';
import type { JournalEntryFilterParams } from '@/renderer/types/accounting';

export function useJournalEntries(params: JournalEntryFilterParams) {
  return useQuery({
    queryKey: queryKeys.accounting.journalsList(params),
    queryFn: async () => {
      const result = await fetchJournalEntries(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch journal entries');
      }
      return result.data;
    },
    enabled: !!params.companyId,
    placeholderData: keepPreviousData,
  });
}
